
















import {
  computed,
  defineComponent,
  useRoute,
  useRouter,
  useContext,
  onMounted,
  ref,
} from '@nuxtjs/composition-api';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import useCart from '~/modules/checkout/composables/useCart';
import CheckoutSkeleton from '~/modules/checkout/components/CheckoutSkeleton.vue';

export default defineComponent({
  name: 'CheckoutPage',
  components: {
    CheckoutSkeleton,
  },
  layout: 'checkout',
  setup() {
    const route = useRoute();
    const { app } = useContext();
    const { path } = route.value;
    const router = useRouter();
    const { cart, load, loading } = useCart();
    const products = computed(() => cartGetters.getItems(cart.value));
    const currentStep = computed(() => path.split('/').pop());
    const isThankYou = computed(() => currentStep.value === 'thank-you');
    // workaround for the issue with child components being mounted twice
    const componentLoaded = ref(false);
    onMounted(async () => {
      await load();
      componentLoaded.value = true;
      if (products.value.length === 0 && currentStep.value !== 'thank-you') {
        await router.push(app.localePath('/'));
      }
    });

    return {
      isThankYou,
      cart,
      loading,
      currentStep,
      componentLoaded,
    };
  },
});
